import styled from 'styled-components';

import { SanityBlockRenderer } from 'components/sanity-block-renderer';

const margin = '0 0 1rem 0';
const padding = '0';
const fontStyle = 'normal';
const fontSize = '0.75rem';

export const Disclaimer = styled(SanityBlockRenderer)`
  margin: ${margin};
  padding: ${padding};
  color: ${Styles.color.grey.one};
  font-style: ${fontStyle};
  font-size: ${fontSize};
  font-family: ${Styles.fontFamily.body};
  a {
    color: ${Styles.color.grey.one};
  }
`;

export const DisclaimerPlain = styled.p`
  margin: ${margin};
  margin-block-start: 1rem;
  padding: ${padding};
  color: ${Styles.color.grey.one};
  font-style: ${fontStyle};
  font-size: ${fontSize};
  font-family: ${Styles.fontFamily.body};
  a {
    color: ${Styles.color.grey.one};
  }
  text-align: center;
`;
